import { styled } from '@mui/material/styles';
import { Box, Button } from '@mui/material';

export const ActionButtonsContainer = styled(Box)(({ theme }) => ({
  padding: 0,
  backgroundColor: 'transparent',
}));

export const ButtonsRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  justifyContent: 'flex-start',
}));

export const CreateOrderButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0.75, 1.5),
  fontSize: '0.75rem',
  background: 'linear-gradient(90deg, #06b6d4 0%, #10b981 100%)',
  color: theme.palette.common.white,
  borderRadius: theme.spacing(1),
  textTransform: 'none',
  boxShadow: theme.shadows[3],
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    background: 'linear-gradient(90deg, #0891b2 0%, #059669 100%)',
    transform: 'scale(1.05)',
    boxShadow: theme.shadows[4],
  },
}));

export const ExportButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0.75, 1.5),
  fontSize: '0.75rem',
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(1),
  textTransform: 'none',
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    backgroundColor:
      theme.palette.mode === 'dark' ? theme.palette.action.hover : theme.palette.common.white,
    borderColor: theme.palette.mode === 'dark' ? theme.palette.divider : theme.palette.grey[400],
    transform: 'scale(1.05)',
    boxShadow:
      theme.palette.mode === 'dark'
        ? '0 1px 3px rgba(0, 0, 0, 0.35)'
        : '0 1px 3px rgba(0, 0, 0, 0.1)',
  },
}));
